import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenCreating, hideWhenDisplaying } from 'src/types/columnFlags';
const controlledActions = {
    create: [9],
    fetch: [10],
    update: [11],
    delete: [12],
    downloadList: [10],
    uploadList: [9]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'row_menu', type: 'row_menu', menuItemShortcuts: ['copy', 'delete'], hideWhenCreating },
        { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left', hideWhenCreating, isNumeric: true, uiFilterTypes: ['selectedValuesFilter', 'textFilters'], isInteger },
        { name: 'native_id', inlineEdit: true, label: 'Native ID', field: 'native_id', align: 'right', uiFilterTypes: ['selectedValuesFilter', 'textFilters'] },
        { name: 'name', label: 'Name', field: 'name', inlineEdit: true, align: 'left', required: true, uiFilterTypes: ['selectedValuesFilter', 'textFilters'], autofocusWhenCreating: true },
        { name: 'parent_id', label: 'Parent', field: 'parent_id', required: true, references: 'products.products', uiFilterTypes: ['selectedValuesFilter', 'textFilters'], editable: true },
        { name: 'product_level_id', label: 'Product level', field: 'product_level_id', required: true, references: 'products.product_levels_org_specific_labels', uiFilterTypes: ['selectedValuesFilter'], editable: true },
        { name: 'member_ids', hideWhenDisplaying }
        // { name: 'created_by_user_name', label: 'Created by', field: 'created_by_user_name', align: 'left', hideWhenCreating: true }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'products.products',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Products'
});
export default localEntity;
